import recentOrderService from '../../services/recent.orders.service';
var state = {
    all: [],
    activeOrder: null
};
var getters = {
    getRecentOrders: function () {
        return state.all;
    },
    getRecentOrderById: function (state) { return function (orderId) {
        for (var _i = 0, _a = state.all; _i < _a.length; _i++) {
            var recentOrder = _a[_i];
            if (recentOrder.id === orderId) {
                return recentOrder;
            }
        }
        return null;
    }; },
    hasRecentOrders: function (state) {
        return (state.all.length > 0);
    },
    getActiveOrder: function (state) {
        return state.activeOrder;
    }
};
var actions = {
    fetchAllRecentOrders: function () {
        if (state.all.length === 0) {
            console.log('no recent orders');
        }
        return state.all;
    },
    setRecentOrders: function (_a, recentOrders) {
        var commit = _a.commit;
        commit('setRecentOrders', recentOrders);
    },
    setActiveOrder: function (_a, activeOrder) {
        var commit = _a.commit;
        commit('setActiveOrder', activeOrder);
    }
};
var mutations = {
    setRecentOrders: function (state, recentOrders) {
        return recentOrderService.convertRecentScriptToOrders(recentOrders, function (populatedOrders) {
            state.all = populatedOrders;
        });
    },
    setActiveOrder: function (state, activeOrder) {
        state.activeOrder = activeOrder;
    }
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/recent.orders.store.ts
// module id = null
// module chunks = 